import { useEffect, useState } from 'react';
import { api, type HouseConfig } from '../api.js';
import { t } from '../i18n.js';
import { DocLinkCard } from './DocLinkCard.js';

export function InfosSection() {
  const [config, setConfig] = useState<HouseConfig | null>(null);

  useEffect(() => {
    void api.getHouseConfig().then(setConfig).catch(() => {});
  }, []);

  return (
    <div className="section-page">
      <h1 className="section-title">{t('infos.title')}</h1>

      <DocLinkCard
        icon="📖"
        title={t('infos.rules_title')}
        url={config?.rules_url ?? null}
        openLabel={t('infos.rules_open')}
        emptyLabel={t('infos.rules_unset')}
        qr
        qrLabel={t('infos.rules_scan')}
      />

      <DocLinkCard
        icon="🔭"
        title={t('infos.telescope_title')}
        url={config?.telescope_url ?? null}
        openLabel={t('infos.telescope_open')}
        emptyLabel={t('infos.telescope_unset')}
      />
    </div>
  );
}
